import { useGlobalToast } from './hooks';
import { Toast } from '../toast';

export const GlobalToast = () => {
  const toastProps = useGlobalToast();

  return <Toast {...toastProps} />;
};
